import {useQuery} from 'react-query'
import {ChapterEditModalForm} from './ChapterEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
// import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
import { getChapterById } from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
// import { getChapterById } from '../../../apps/chapter-management/chapters-list/core/_requests'
// import {getChapterById} from '../core/_requests'

const ChapterEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: chapter,
    error,
  } = useQuery(
    `${QUERIES.CHAPTERS_LIST}-chapter-${itemIdForUpdate}`,
    () => {
      return getChapterById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ChapterEditModalForm isChapterLoading={isLoading} chapter={{id: undefined}} />
  }

  if (!isLoading && !error && chapter) {
    return <ChapterEditModalForm isChapterLoading={isLoading} chapter={chapter} />
  }

  return null
}

export {ChapterEditModalFormWrapper}
